import { ILogEntry } from "motw_core/Entity/ILogEntry";
import { GetTodaysLogEntries } from "./GetTodaysLogEntries";
import { SetNavigationMenuItemBadge } from "../../Shared/ActivePanel/NavigationMenu/NavigationMenuItem/NavigationMenuItemBadge/NavigationMenuItemBadge";
import { EPanelId } from "source/app/services/Shared/EPanelId";
import { EBadgeColor } from "../../Shared/ActivePanel/NavigationMenu/NavigationMenuItem/NavigationMenuItemBadge/EBadgeColor/EBadgeColor";

export function SetLogNavBadge(logEntries: ILogEntry[]) {
    const todaysLogEntries = GetTodaysLogEntries(logEntries);

    SetNavigationMenuItemBadge(
        EPanelId.Habits,
        todaysLogEntries.length,
        EBadgeColor.green
    );
}
